import { selectDateRules } from '../../../../../../shared/constants/fieldsData';
import {
  compareWithInitVal,
  fieldDataTypes,
} from '../../../../../../shared/lib/formFieldValidators';
import { compareToStartDate } from '../../../lib/fieldValidators';

export const getValidationRules = ({ initialValue, editMode, entity }) =>
  editMode
    ? [
        ...selectDateRules,
        {
          validator: compareWithInitVal(initialValue, fieldDataTypes.date),
        },
        { validator: compareToStartDate(entity) },
      ]
    : [...selectDateRules, { validator: compareToStartDate(entity) }];
